<template>
    <div class="article-detail">
        <common-header />
        <div class="content-wrap">
            <div class="content">
                <div class="sidebar">
                    <div :class="{'sticky': isSticky}" v-if="newsTypeData">
                        <div class="menu-toggle">
                            <img v-if="showMenu" src="@/assets/menu_unfold.svg" @click="showMenu = !showMenu">
                            <img v-else src="@/assets/menu_fold.svg" @click="showMenu = !showMenu">
                        </div>
                        <menu-tree v-if="showMenu" :newsTypeData="newsTypeData" />
                        <div v-else class="animate__animated animate__fadeInUp">
                            <div class="type"><span class="date">{{newsTime}}</span>- {{newsTypeData.typeName}}</div>
                            <h2 v-dompurify-html="title"></h2>
                        </div>
                    </div>
                </div>
                <div class="main" v-if="!loading">
                    <video v-if="newsDetailShow === 'show_vedio'" :src="videoUrl" controls></video>
                    <img v-if="newsDetailShow === 'show_img'" class="picture" :src="pictureUrl" alt="封面图">
                    <article class="animate__animated animate__fadeInUp">
                        <div class="info">
                            <span v-if="newsFromTile">
                                {{$t('message.source')}}：
                                <template v-if="newsFromAddress">
                                    <a :href="newsFromAddress" target="_blank">{{newsFromTile}}</a>
                                </template>
                                <template v-else>
                                    {{newsFromTile}}
                                </template>
                            </span>
                            <span v-if="newsFromAuthor">{{newsFromAuthor}}</span>
                        </div>
                        <div class="text" v-dompurify-html="content"></div>
                        <span v-if="attachmentUrl">{{$t('message.download')}}：<a href="javascript:;" @click="download(attachmentUrl, attachmentName)">{{attachmentName}}</a></span>
                    </article>
                </div>
            </div>
            <div class="video-bg">
                <video autoplay playsinline muted loop src="@/assets/media/bg.mp4"></video>
            </div>
        </div>
        <common-footer />
    </div>
</template>

<script>
import http from 'axios';
import Api from '@/api/index.js';
import CommonHeader from '@/components/CommonHeader.vue';
import CommonFooter from '@/components/CommonFooter.vue';
import MenuTree from './MenuTree.vue';

export default {
    name: "NewsDetail",
    data() {
        return {
            showMenu: false,
            id: '',
            title: '',
            content: '',
            newsTypeData: null,
            pictureUrl: '',
            videoUrl: '',
            newsDetailShow: '',
            attachmentUrl: '',
            attachmentName: '',
            newsTime: '',
            newsFromTile: '',
            newsFromAddress: '',
            newsFromAuthor: '',
            loading: false,
            isSticky: false
        };
    },
    watch: {
        '$route.params.id'() {
            this.init();
        },
        '$i18n.locale'() {
            this.init();
        }
    },
    created() {
        this.init();
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        init() {
            this.loading = true;
            const id = this.$route.params.id;
            Api.getNewsDetail({
                lang: this.$i18n.locale,
                id
            }).then(res => {
                if (res.data.newsVo) {
                    const {title, content, newsTypeId, newsTypeName, pictureUrl, newsDetailShow, attachmentName, videoUrl, attachmentUrl, newsTime, newsFromTile, newsFromAddress, newsFromAuthor} = res.data.newsVo;
                    this.title = title;
                    this.content = content;
                    this.newsTypeData = {
                        typeId: newsTypeId,
                        typeName: newsTypeName
                    };
                    this.pictureUrl = pictureUrl;
                    this.videoUrl = videoUrl;
                    this.newsDetailShow = newsDetailShow;
                    this.attachmentUrl = attachmentUrl;
                    this.attachmentName = attachmentName;

                    this.newsTime = newsTime;
                    this.newsFromTile = newsFromTile;
                    this.newsFromAddress = newsFromAddress;
                    this.newsFromAuthor = newsFromAuthor;
                    this.loading = false;
                }
            });
        },
        download(url, filename) {
            http.get(url, {
                responseType: 'blob'
            }).then(({data}) => {
                this.saveAs(data, filename);
            });
        },
        saveAs(blob, filename) {
            if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename);
            } else {
                let link = document.createElement('a');
                let body = document.querySelector('body');

                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                link.style.display = 'none';
                body.appendChild(link);
                link.click();
                body.removeChild(link);
                window.URL.revokeObjectURL(link.href);
            }
        },
        handleScroll() {
            this.isSticky = window.pageYOffset > 0;
        }
    },
    components: {
        CommonHeader,
        CommonFooter,
        MenuTree
    }
};
</script>
<style lang="less">
@import "@/styles/detail.less";
</style>
